import { useState } from "react";
import UserSelector from "./components/UserSelector";
import Leaderboard from "./components/Leaderboard";
import AddUser from "./components/AddUser";
import History from "./components/History";
import "./App.css";


function App() {
  const [refresh, setRefresh] = useState(0);

  return (
    <div className="main" >
      <h1>🏆 Leaderboard Task</h1>
      <UserSelector onClaim={() => setRefresh(refresh + 1)} />
      <AddUser onAdd={() => setRefresh(refresh + 1)} />
      <Leaderboard refresh={refresh} />
      <History refresh={refresh} />
    </div>
  );
}

export default App;
